import { createContext, useContext, useId, useRef } from "react";

const ViewportContext = createContext<string | null>(null);

interface ViewportProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  as?: React.ElementType;
  viewportId?: string;
}

export function Viewport({
  children,
  className,
  style,
  as: Component = "div",
  viewportId: propViewportId,
}: ViewportProps) {
  const internalViewportId = useId();
  const viewportId = propViewportId || internalViewportId;
  const elementRef = useRef<HTMLElement>(null);

  return (
    <ViewportContext.Provider value={viewportId}>
      <Component data-viewport-id={viewportId} ref={elementRef} className={className} style={style}>
        {children}
      </Component>
    </ViewportContext.Provider>
  );
}

export function useViewportId() {
  const viewportId = useContext(ViewportContext);
  return viewportId ?? "root";
}
